/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderLeftPlus = createReactComponent("outline", "border-left-plus", "IconBorderLeftPlus", [["path", { "d": "M4 20v-16", "key": "svg-0" }], ["path", { "d": "M8 4v.01", "key": "svg-1" }], ["path", { "d": "M12 4v.01", "key": "svg-2" }], ["path", { "d": "M16 4v.01", "key": "svg-3" }], ["path", { "d": "M20 4v.01", "key": "svg-4" }], ["path", { "d": "M20 8v.01", "key": "svg-5" }], ["path", { "d": "M20 12v.01", "key": "svg-6" }], ["path", { "d": "M20 16v.01", "key": "svg-7" }], ["path", { "d": "M8 20v.01", "key": "svg-8" }], ["path", { "d": "M12 20v.01", "key": "svg-9" }], ["path", { "d": "M16 20v.01", "key": "svg-10" }], ["path", { "d": "M20 20v.01", "key": "svg-11" }], ["path", { "d": "M9 12h6", "key": "svg-12" }], ["path", { "d": "M12 9v6", "key": "svg-13" }]]);

export { IconBorderLeftPlus as default };
//# sourceMappingURL=IconBorderLeftPlus.mjs.map
